import { Navigate, useParams, useSearchParams } from 'react-router-dom';

import store from '../redux/store';

import Employees from './adminData/employees/EmployeesComponent';
import EmployeeNew from './adminData/employees/EmployeeNewComponent';
import EmployeeManagement from './adminData/employees/EmployeeManagementComponent';
import AuthorizationIscirManagement from './adminData/employees/AuthzIscirManagementComponent';
import AuthorizationIscirNew from './adminData/employees/AuthzIscirNewComponent';
import AuthzIscirCourseNew from './adminData/employees/AuthzIscirCourseNewComponent';
import AuthzIscirCourseManagement from './adminData/employees/AuthzIscirCourseManagementComponent';
import AuthzInternalNew from './adminData/employees/AuthzInternalNewComponent';
import AuthzInternalManagement from './adminData/employees/AuthzInternalManagementComponent';
import { EmployeesDataLoader } from './AFStoreDataRefresh';
import { RefreshEmployeesCachedData, RefreshRsvtiOperators, RefreshAuthzsCache } from './AFStoreDataRefresh';
import { DispatchAF } from './AFStoreDispatchAction';
import * as ReduxDataStatus from '../utils/constants/ReduxDataStatus';


export const EmployeesPage = () => {
    const reduxStore = store.getState();

    console.log("#### EmployeesPage");

    var dataStatus;
    if( reduxStore.clients.status === ReduxDataStatus.LOADING || reduxStore.clients.status === ReduxDataStatus.IDLE ||
        reduxStore.employers.status === ReduxDataStatus.LOADING || reduxStore.employers.status === ReduxDataStatus.IDLE
    ) {
        
        dataStatus = ReduxDataStatus.LOADING;
    }
    else {
        dataStatus = ReduxDataStatus.SUCCEEDED;
    }

    return (
        <Employees
            loadComponentData={EmployeesDataLoader}
            dataStatus={dataStatus}
            employees={reduxStore.employees}
            employers={reduxStore.employers.employers}
            worksites={reduxStore.worksites.worksites}
            clients={reduxStore.clients}
            corCodes={reduxStore.staticData.corCodes}
        />
    );
}


export const EmployeeNewPage = () => {
    const reduxStore = store.getState();

    return (
        <EmployeeNew
            postEmployee={DispatchAF.postEmployee}
            mostRecentEmployeeId={reduxStore.bucket.bucket.mostRecentEmployeeId}
            employers={reduxStore.employers.employers}
            corCodes={reduxStore.staticData.corCodes}
        />
    );
}


export const EmployeeManagementPage = () => {
    const reduxStore = store.getState();

    console.log('#### EmployeeManagementPage');

    const { employeeId } = useParams();
    const eeId = parseInt(employeeId, 10);

    // The employerId would be passed in when the user navigates directly to the user (i.e. Reports, Tasks, ...),
    // not from Employees page, which would insure that the employees are loaded for the right employer
    let [searchParams, setSearchParams] = useSearchParams();
    const employerId = searchParams.get("employerId");
    const erId = employerId ? parseInt(employerId, 10) : null;

    const employee = reduxStore.employees.employees.find((employee) => employee.id === eeId);
    var wsId = null;
    var clId = null;
    if(employee) {
        // eeId = props.employee.id;
        wsId = employee.employmentDetails.workSiteId;
        const employer = reduxStore.employers.employers.find((employer) => employer.id === employee.employmentDetails.employerId);
        if (employer) {
            clId = employer.generalSection.rsvtiMBClientId;
        }
    }

    // Should the dataStatus be just 'reduxStore.employees.status'
    var dataStatus;
    if( reduxStore.employees.status === ReduxDataStatus.LOADING || reduxStore.employees.status === ReduxDataStatus.IDLE || 
        (erId && !reduxStore.employees.loadCriteria.employerId) ||
        (erId && reduxStore.employees.loadCriteria.employerId != erId) ) {
        
        dataStatus = ReduxDataStatus.LOADING;
    }
    else {
        dataStatus = ReduxDataStatus.SUCCEEDED;
    }

    return (
        <EmployeeManagement
            loadComponentData={function(){ return EmployeeManagementDataLoader(eeId, erId, wsId, clId)} }
            dataStatus={dataStatus}
            employee={employee}
            patchEmployee={DispatchAF.patchEmployee}
            employers={reduxStore.employers.employers}
            authorizations={reduxStore.authorizations.authorizations}
            authorizationsDataStatus={reduxStore.authorizations.status}
            corCodes={reduxStore.staticData.corCodes}
        />
    );
};


const EmployeeManagementDataLoader =(employeeId, employerId, worksiteId, clientId) => {
    if(employerId)
        RefreshEmployeesCachedData(employerId);
    if(employeeId)
        RefreshAuthzsCache(employeeId);
    if(worksiteId && clientId)
        RefreshRsvtiOperators(worksiteId, clientId);
}


export const AuthzIscirManagementPage = () => {
    const reduxStore = store.getState();

    console.log('#### AuthzIscirManagementPage');

    const { authzId } = useParams();
    const aId = parseInt(authzId, 10);

    // some Authzs have the ID as String...needs to be updated
    const authz = reduxStore.authorizations.authorizations.find((authz) => authz.id == aId);
    if(authz){
        authz.id = aId;
    }

    const employee = reduxStore.employees.employees.find((employee) => employee.id === authz.autorizatie.employeeId)
    const course = reduxStore.employeeCourses.courses.find((course) => course.id === aId)

    return(
        <AuthorizationIscirManagement 
            authorization={authz}
            employee={employee}
            employer={reduxStore.employers.employers.find((employer) => employer.id === employee.employmentDetails.employerId)}
            worksite={reduxStore.worksites.worksites.find((worksite) => worksite.id === employee.employmentDetails.workSiteId)}
            course={course}
            rsvtiOperators={reduxStore.rsvtiOperators.rsvtiOperators}
            saveAuthorization={DispatchAF.patchAuthISCIR}
            saveAuthzImage={DispatchAF.postAuthzIscirImage}
        />
    );

}

export const AuthzIscirNewPage = () => {
    const reduxStore = store.getState();


    console.log('#### AuthzIscirNewPage');

    let [searchParams, setSearchParams] = useSearchParams();

    if(reduxStore.bucket.bucket.mostRecentAuthzId != null) {
        return(
            <Navigate to={`/employees/authzs/iscir/${reduxStore.bucket.bucket.mostRecentAuthzId}`} replace />
        );
    }

    const eeId = searchParams.get("employeeId");
    const employeeId = eeId ? parseInt(eeId, 10) : null;

    const employee = reduxStore.employees.employees.find((employee) => employee.id === employeeId)

    return(
        <AuthorizationIscirNew 
            employee={employee}
            employer={reduxStore.employers.employers.filter((employer) => employer.id === employee.employmentDetails.employerId)[0]}
            worksite={reduxStore.worksites.worksites.filter((worksite) => worksite.id === employee.employmentDetails.workSiteId)[0]}
            createAuthorization={DispatchAF.postAuthISCIR}
        />
    );
}


export const AuthzInternalNewPage = () => {
    const reduxStore = store.getState();
    console.log('#### AuthzInternalNewPage');

    let [searchParams, setSearchParams] = useSearchParams();

    if(reduxStore.bucket.bucket.mostRecentAuthzId != null) {
        return(
            <Navigate to={`/employees/authzs/internal/${reduxStore.bucket.bucket.mostRecentAuthzId}`} replace />
        );
    }

    const eeId = searchParams.get("employeeId");
    const employeeId = eeId ? parseInt(eeId, 10) : null;

    const employee = reduxStore.employees.employees.find((employee) => employee.id === employeeId)

    return(
        <AuthzInternalNew 
            employee={employee}
            employer={reduxStore.employers.employers.find((employer) => employer.id === employee.employmentDetails.employerId)}
            worksite={reduxStore.worksites.worksites.find((worksite) => worksite.id === employee.employmentDetails.workSiteId)}
            rsvtiOperators={reduxStore.rsvtiOperators.rsvtiOperators}
            createAuthorization={DispatchAF.postAuthzInternal}
        />
    );
}

export const AuthzInternalManagementPage = () => {
    const reduxStore = store.getState();
    console.log('#### AuthzInternalManagementPage');

    const { authzId } = useParams();
    const aId = parseInt(authzId, 10);

    const authz = reduxStore.authorizations.authorizations.find((authz) => authz.id == aId);

    const employee = reduxStore.employees.employees.find((employee) => employee.id === authz.autorizatie.employeeId)

    return(
        <AuthzInternalManagement 
            authorization={authz}
            employee={employee}
            employer={reduxStore.employers.employers.find((employer) => employer.id === employee.employmentDetails.employerId)}
            worksite={reduxStore.worksites.worksites.find((worksite) => worksite.id === employee.employmentDetails.workSiteId)}
            rsvtiOperators={reduxStore.rsvtiOperators.rsvtiOperators}
            saveAuthorization={DispatchAF.patchAuthzInternal}
            saveAuthzCert={DispatchAF.postAuthzInternalCert}
        />
    );

}


export const AuthzIscirCourseNewPage = () => {
    const reduxStore = store.getState();
    console.log('#### AuthzIscirCourseNewPage');

    let [searchParams, setSearchParams] = useSearchParams();

    if(reduxStore.bucket.bucket.mostRecentEeCourseId != null) {
        return(
            <Navigate to={`/employees/authzcourse/${reduxStore.bucket.bucket.mostRecentEeCourseId}`} replace />
        );
    }

    const eeId = searchParams.get("employeeId");
    const employeeId = eeId ? parseInt(eeId, 10) : null;

    const auId = searchParams.get("authzId");
    const authzId = eeId ? parseInt(auId, 10) : null;
    
    const employee = reduxStore.employees.employees.find((employee) => employee.id === employeeId)
    const authz = reduxStore.authorizations.authorizations.find((authz) => authz.id == authzId);

    return(
        <AuthzIscirCourseNew 
            employee={employee}
            authorization={authz}
            postEmployeeCourse={DispatchAF.postEmployeeCourse}
        />
    );
}

export const AuthzIscirCourseManagePage = () => {
    const reduxStore = store.getState();
    console.log('#### AuthzIscirCourseManagePage');

    const { courseId } = useParams();
    const acId = parseInt(courseId, 10);

    const course = reduxStore.employeeCourses.courses.find((course) => course.id === acId)

    if(!course) {
        // course could have been completed - deleted from cache
        return(
            <Navigate to={`/employees/authzs/iscir/${courseId}`} replace />
        );
    }

    const authz = reduxStore.authorizations.authorizations.find((authz) => authz.id == acId);
    const employee = reduxStore.employees.employees.find((employee) => employee.id === course.details.employeeId)

    return(
        <AuthzIscirCourseManagement 
            course={course}
            employee={employee}
            authorization={authz}
            patchEmployeeCourse={DispatchAF.patchEmployeeCourse}
            saveEmployeeCourseCert={DispatchAF.postEmployeeCourseCert}
        />
    );
}
